/* eslint-disable class-methods-use-this */
import * as yup from 'yup';
import GenericField from './genericField';

export default class MaskedField extends GenericField {
  constructor(
    name,
    label,
    mask,
    {
      placeholder = undefined,
      required = false,
      requiredMessage = undefined,
      ariaLabel = undefined,
      min = undefined,
      max = undefined,
      matches = undefined,
      oneOf = undefined,
      helperText = undefined,
      test = undefined,
      type = undefined,
      formatChars = undefined,
      disabled = undefined,
      disableUnderline = undefined,
    } = {},
  ) {
    super(name, label);
    this.placeholder = placeholder;
    this.required = required;
    this.requiredMessage = requiredMessage;
    this.ariaLabel = ariaLabel;
    this.matches = matches;
    this.min = min;
    this.max = max;
    this.oneOf = oneOf;
    this.test = test;
    this.mask = mask;
    this.type = type;
    this.helperText = helperText;
    this.formatChars = formatChars;
    this.disabled = disabled;
    this.disableUnderline = disableUnderline;
  }

  forView(value) {
    return value;
  }

  forFormInitialValue(value) {
    return value;
  }

  forForm() {
    let yupChain = yup
      .string()
      .nullable(true)
      .trim()
      .label(this.label);

    if (this.required) {
      yupChain = yupChain.required(this.requiredMessage);
    }

    if (this.min && this.min.length > 0) {
      yupChain = yupChain.min(this.min.length, this.min.message);
    }

    if (this.max && this.max.length > 0) {
      yupChain = yupChain.max(this.max.length, this.max.message);
    }

    if (this.matches) {
      yupChain = yupChain.matches(this.matches.pattern, this.matches.message || this.requiredMessage);
    }

    if (this.oneOf) {
      yupChain = yupChain.oneOf(this.oneOf);
    }

    if (this.test) {
      this.test.forEach(testIndex => {
        yupChain = yupChain.test(testIndex);
      });
    }

    return yupChain;
  }
}
